module.exports = __webpack_public_path__ + "static/media/CheckABminiopaque.48a877ce.png";